const HisTrash2 = ({ color, sx }) => {
  const strokeColor = color ?? "#4C2AC6";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.07959 5.69116H19.5796"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7459 5.69116V18.5245C17.7459 19.4412 16.8293 20.3578 15.9126 20.3578H6.74593C5.82926 20.3578 4.9126 19.4412 4.9126 18.5245V5.69116"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6626 5.69108V3.85775C7.6626 2.94108 8.57926 2.02441 9.49593 2.02441H13.1626C14.0793 2.02441 14.9959 2.94108 14.9959 3.85775V5.69108"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.49609 10.2744V15.7744"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1626 10.2744V15.7744"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisTrash2;
